import React, { useState } from 'react';
import FundraisingSimulationClient from '../../../models/fundraisingSimulations/fundraisingSimulationClient';

interface ResultData {
  score: number;
  simulatedAmount: number | null;
  unit: string | null;
  range: string | null;
}

interface Props {
  type: string;
  resultData: ResultData;
}

const SimulatorResults = (props: Props) => {
  const [loading, setLoading] = useState(false);
  const fundraisingSimulationClient = new FundraisingSimulationClient();

  // 返却パラメータの加工用
  const toNumOrNull = (value: string | number): number | null => {
    const num = Number(value);
    return isNaN(num) || value === '' ? null : num;
  };

  const handleSubmit = (event: React.MouseEvent<HTMLAnchorElement>) => {
    event.preventDefault();

    if (loading) return;
    setLoading(true);

    // SessionStorageから保存された情報を取得
    const cachedData = JSON.parse(sessionStorage.getItem(props.type) || '{}');
    const formData = cachedData.formData || {};
    const selectedTagIds = cachedData.selectedTagIds || [];

    // シミュレーション結果を保存する
    fundraisingSimulationClient
      .create({
        type: props.type,
        fundraising_simulation: {
          president_age: toNumOrNull(formData.presidentAge),
          birth_on: toNumOrNull(formData.birthOn),
          business_type: toNumOrNull(formData.businessType),
          requested_funding_amount: toNumOrNull(
            formData.requestedFundingAmount,
          ),
          total_funding_amount: toNumOrNull(formData.totalFundingAmount),
          current_valuation: toNumOrNull(formData.currentValuation),
          previous_period_sales: toNumOrNull(formData.previousPeriodSales),
          financial_status: toNumOrNull(formData.financialStatus),
        },
        fundraising_simulation_tag: {
          ids: selectedTagIds,
        },
      })
      .finally(() => {
        // ユーザの見た目上はリンクのため、apiの結果を問わず遷移はする
        const urlParams = new URLSearchParams({ ref: 'sim' });
        window.location.href = `/company_contact?${urlParams.toString()}`;
      });
  };

  if (props.resultData?.simulatedAmount == null) {
    return null;
  }

  return (
    <div
      className={
        props.resultData.simulatedAmount === 0
          ? 'diagnosis-result--none'
          : 'diagnosis-result'
      }
    >
      <div className="score-text">診断結果</div>
      {props.resultData.simulatedAmount === 0 ? (
        <div className="score-text-wrap">
          <p>
            大変申し訳ございませんが、現在、弊社の
            <br className="pc-none" />
            データ不足で表示できません。
          </p>
          <p>
            資金調達の可能性も含め、
            <br className="pc-none" />
            お気軽にご相談ください。
          </p>
        </div>
      ) : (
        <>
          {props.type === 'ecf' && (
            <p>
              株式投資型
              <br className="pc-none" />
              クラウドファンディングを活用して
            </p>
          )}
          {props.type === 'plus' && (
            <p>
              大型資金調達
              <br className="pc-none" />
              サービスを活用して
            </p>
          )}
          <div className="value-block">
            <div className="value">
              {props.resultData.simulatedAmount?.toLocaleString()}
            </div>
            <span className={props.type === 'plus' ? 'plus-unit' : ''}>
              {`${props.resultData.unit ?? ''}円
                ${props.resultData.range ?? ''}`}
            </span>
          </div>
          <p>
            の資金調達をご支援できる
            <br className="pc-none" />
            可能性があります
          </p>
        </>
      )}
      <a href="/company_contact" onClick={handleSubmit}>
        今すぐ資金調達の相談をする
      </a>
      {props.resultData.simulatedAmount !== 0 && (
        <p className="note-text">
          ※ 本シミュレーション結果は、参考情報として提供するものであり、
          <br className="sp-none" />
          資金調達の実現や調達金額、条件等を保証・約束するものではありません。
        </p>
      )}
    </div>
  );
};

export default SimulatorResults;
